import React from "react";
import PropTypes from "prop-types";

/**
 * Clear/Close icon component - displays an X inside a circle
 * Used in SearchBar and other components for clearing inputs
 */
export function ClearIcon({ width = 12, height = 12, className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      className={className}
    >
      <path
        d="M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z"
        fill="black"
      />
      <path
        d="M6 11.625C9.1066 11.625 11.625 9.1066 11.625 6C11.625 2.8934 9.1066 0.375 6 0.375C2.8934 0.375 0.375 2.8934 0.375 6C0.375 9.1066 2.8934 11.625 6 11.625Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.36768 4.29125C4.51789 4.14105 4.76141 4.14105 4.91161 4.29125L7.8165 7.19613C7.9667 7.34634 7.9667 7.58986 7.8165 7.74006C7.66629 7.89026 7.42277 7.89026 7.27257 7.74006L4.36768 4.83518C4.21748 4.68498 4.21748 4.44145 4.36768 4.29125Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.73975 4.29127C7.88996 4.44147 7.88996 4.68499 7.73975 4.8352L4.83487 7.74008C4.68467 7.89028 4.44115 7.89028 4.29094 7.74008C4.14074 7.58988 4.14074 7.34635 4.29094 7.19615L7.19583 4.29127C7.34603 4.14107 7.58955 4.14107 7.73975 4.29127Z"
        fill="white"
      />
    </svg>
  );
}

ClearIcon.propTypes = {
  /** Width of the icon in pixels */
  width: PropTypes.number,
  /** Height of the icon in pixels */
  height: PropTypes.number,
  /** Additional CSS class name */
  className: PropTypes.string,
};
